// components/auth/ProtectedRoute.jsx
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../hooks/useAuth';

export const ProtectedRoute = ({ children }:any) => {
    const { user, isLoading } : any= useAuth();
    
    console.log('ProtectedRoute - Current state:', {
        isLoading,
        user: user ? user.email : 'null'
    });
    
    // Show minimal loading
    if (isLoading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <div className="w-12 h-12 border-4 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading...</p>
                </div>
            </div>
        );
    }

    // If not authenticated, redirect to login
    if (!user) {
        console.log('No user found, redirecting to login');
        return <Navigate to="/login" replace />;
    }

    // If authenticated, render the children
    return <>{children}</>;
};